import React from 'react'
import MaterialSymbol from '../material-symbol'

const LiveHelp = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="live_help" {...props} />
))

LiveHelp.displayName = 'LiveHelp'

export default LiveHelp
